import { cn } from '@/lib/utils';

export type OverlayProps = {
  fullScreen?: boolean;
  darkOverlay?: boolean;
  classNames?: { root?: string };
};

export function Overlay({ fullScreen, darkOverlay, classNames }: OverlayProps) {
  return (
    <div
      data-header-blur-background
      className={cn(
        'fixed left-0 top-12 z-10 h-full w-full backdrop-blur-sm md:top-16',
        fullScreen && 'top-0',
        darkOverlay && 'bg-neutral-N99/50',
        classNames?.root
      )}
    />
  );
}
